var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMappinIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3677 18.4956C14.4044 16.7406 18.0279 13.155 18.0279 9.86456C18.0279 8.04397 17.2892 6.29794 15.9744 5.01058C14.6596 3.72323 12.8763 3 11.0169 3C9.15743 3 7.37415 3.72323 6.05934 5.01058C4.74452 6.29794 4.00586 8.04397 4.00586 9.86456C4.00586 13.155 7.62821 16.7406 9.66608 18.4956C10.0378 18.8205 10.5186 19 11.0169 19C11.5151 19 11.9959 18.8205 12.3677 18.4956ZM8.67986 9.86456C8.67986 9.2577 8.92608 8.67569 9.36436 8.24657C9.80263 7.81745 10.3971 7.57637 11.0169 7.57637C11.6367 7.57637 12.2311 7.81745 12.6694 8.24657C13.1076 8.67569 13.3539 9.2577 13.3539 9.86456C13.3539 10.4714 13.1076 11.0534 12.6694 11.4826C12.2311 11.9117 11.6367 12.1527 11.0169 12.1527C10.3971 12.1527 9.80263 11.9117 9.36436 11.4826C8.92608 11.0534 8.67986 10.4714 8.67986 9.86456Z",
    fill: "#1C3D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappinIconBlue);
export default __webpack_public_path__ + "static/media/mappin-icon-blue.40b5a6f59d923b8dfdf465cedafc770f.svg";
export { ForwardRef as ReactComponent };